var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";
import { useEffect, useMemo, useState } from "react";
/** <b>Composant d'affichage en mode édition d'un champ de type radio</b>*/
export default function RadioFieldEdit(_a) {
    var fieldName = _a.fieldName, record = _a.record, onUpdate = _a.onUpdate, fieldMetadata = _a.fieldMetadata;
    var t = useTranslation(["common"]).t;
    var defaultValue = useMemo(function () {
        if (!record) {
            return;
        }
        return record[fieldName || ""] || (fieldMetadata === null || fieldMetadata === void 0 ? void 0 : fieldMetadata.default);
    }, [fieldName, record]);
    var _b = useState(0), key = _b[0], setKey = _b[1]; // State to hold the key value
    useEffect(function () {
        // Update the key value whenever defaultValue changes
        setKey(function (prevKey) { return prevKey + 1; });
    }, [defaultValue]);
    var _c = useState(), value = _c[0], setValue = _c[1];
    var options = function () {
        var optionsObejct = t("app_lists")[fieldMetadata.options] || {};
        var values = [];
        for (var p in optionsObejct) {
            values.push({ value: p, label: optionsObejct[p] });
        }
        return values;
    };
    useEffect(function () {
        setValue(defaultValue || "");
    }, [defaultValue]);
    var optionList = options();
    /* return (
      <div>
        <Select
          key={key}
          className="w-full h-8 rounded-md border border-[--color-gray-300] p-1 justify-center shadow cursor-pointer"
          defaultValue={defaultValue || ""}
          onChange={(event, value) => {
            setValue(value || "");
            if (onUpdate) {
              onUpdate({ [fieldName as string]: value });
            }
          }}
        >
          {optionList &&
            optionList.map((option: any, index: any) => (
              <Option value={option.value} key={index}>
                {option.value}
              </Option>
            ))}
        </Select>
      </div>
    );*/
    var handleRadioChange = function (event) {
        var _a;
        var selectedValue = event.target.value;
        setValue(selectedValue);
        if (onUpdate) {
            onUpdate((_a = {}, _a[fieldName] = selectedValue, _a));
        }
    };
    return (_jsx("div", __assign({ className: "flex flex-col" }, { children: optionList &&
            optionList.map(function (option, index) { return (_jsxs("label", __assign({ className: "flex items-center mb-2" }, { children: [_jsx("input", { type: "radio", name: fieldName, value: option.value, checked: value === option.value, onChange: handleRadioChange, className: "mr-2" }), option.value] }), index)); }) })));
}
